export const universityApi = {
    getUniversity: 'v1/api/university',
    getUniversityByUniCountry: 'v1/api/university?tenant=',
    getUniversityById: 'v1/api/university/getById/',
    getUniversityEntry:'v1/api/universityEntryRequirement/admin',
    postUniversityEntry: 'v1/api/universityEntryRequirement',
    putUniversityEntry: 'v1/api/universityEntryRequirement',
    getUniversityEntryById:'v1/api/universityEntryRequirement',
    getUniversityProcess:'v1/api/universityProcessLink',
    getUniversityProcessApplication:'v1/api/universityProcessLink/application',
    getUniversityProcessById:'v1/api/universityProcessLink/getUniversityProcessLink',
    getUniversityFilter:'v1/api/universityFilter',
    postuniversity:'v1/api/university',
    getUniversityCommission: 'v1/api/universityCommission',
    universityAdmin: 'v1/api/university/admin?universityId=',
    getUniversityDoc: 'v1/api/universityDocuments/getById/',
    addUniversityDoc: 'v1/api/universityDocuments/',
    deleteUniversityDoc: 'v1/api/universityDocuments?id=',
    getUniversityEmails: 'v1/api/universityEmail',
    getUniversityEmailsById: 'v1/api/universityEmail/getById/',
    addUniversityEmails: 'v1/api/universityEmail',
    updateUniversityEmails: 'v1/api/universityEmail?universityEmailId=',
    deleteUniversityEmail: 'v1/api/universityEmail?universityEmailId=',
    getUniversityPG: 'v1/api/universityPg',
    getUniversityPGById: 'v1/api/universityPg/getById/',
    addUniversityPG: 'v1/api/universityPg',
    updateUniversityPG: 'v1/api/universityPg?universityPgId=',
    deleteUniversityPG: 'v1/api/universityPg?id=',
    getUniversityUG: 'v1/api/universityUg',
    getUniversityUGById: 'v1/api/universityUg/getById/',
    addUniversityUG: 'v1/api/universityUg',
    updateUniversityUG: 'v1/api/universityUg?universityUgId=',
    deleteUniversityUG: 'v1/api/universityUg?id=',
    getUniversityAffiliate: 'v1/api/universityAffiliate',
    getUniversityAffiliateById: 'v1/api/universityAffiliate/getById/',
    addUniversityAffiliate: 'v1/api/universityAffiliate',
    updateUniversityAffiliate: 'v1/api/universityAffiliate?universityAffiliateId=',
    deleteUniversityAffiliate: 'v1/api/universityAffiliate?id=',
    deleteUniversityProcessLink: 'v1/api/universityProcessLink?id=',
    uploadUniversityDoc: 'v1/api/university/uploadUniversityDoc?universityId=',
    getUniversityUploadDoc: 'v1/api/universityUploadDoc?universityId=',
    updateUploadDocShowAgent: 'v1/api/universityUploadDoc/changeShowAgent',
    addUniversityUploadDoc: 'v1/api/universityUploadDoc?universityId=',
    deleteUniversityUploadDoc: 'v1/api/universityUploadDoc?id=',
    getUniversityCourse:'v1/api/university/universityCourse?universityId=',
    updateUniversityCourse:'v1/api/university/universityCourse?universityId=',
    getListOfApplicationProcessCATCPTART: 'v1/api/applicationProcess',
    getSingleApplicationProcessCATCPTART: 'v1/api/applicationProcess/getByUniversityId/',
    getAssignedUserInfo: 'v1/api/applicationProcess/getreassignuser',
    updateApplicationProcessCATCPTART: 'v1/api/applicationProcess',
    getUniversityURM: 'v1/api/university/urm/list',
    getUniversityURMList: 'v1/api/university/urmlist',
    getFormByUniversity: 'v1/api/formsMaster/getById?universityId=',
    getUniversityForApplyCourse: 'v1/api/courses/website/uneeqFilter',
    getUniversityByIds: 'v1/api/university/getUniversityByIds',
    saveUniversityFormRequirment: 'v1/api/universityFormRequirment',
    updateEntryReq: 'v1/api/university/updateRequirements',
    createQuestion: 'v1/api/formFields',
    getAssignedUniversities:'v1/api/applicationCptList/getAssignedUniversities',
    updateUniversityFormSetting: 'v1/api/universityFormRequirment/updateUniversityFormStatus',
    deleteUniversityFormRequirment: 'v1/api/universityFormRequirment',
}
